import fetch from './fetch';
let HEALTHAPI = process.env.VUE_APP_HEALTH_API;
let VUE_APP_LAIKANG_API = process.env.VUE_APP_LAIKANG_API;
// 登录后去token
export function authLogin(params) {
    return fetch({
        url: '/auth/login',
        contentType: 'application/json',
        baseUrl: HEALTHAPI,
        method: 'post',
        params,
    });
}
//token刷新接口
export function refreshToken(params) {
    return fetch({
        url: '/auth/refreshToken',
        baseUrl: HEALTHAPI,
        method: 'post',
        params,
    });
}
//查询咨询会话列表
export function getConsultList(params) {
  return fetch({
    url: '/consult/getConsultList',
    header: {
      authorization: uni.getStorageSync('authorization'),
    },
    contentType: 'application/json',
    baseUrl: HEALTHAPI,
    method: 'get',
    params,
  });
}
//邀请专家-获取专家列表
export function getDoctorList(params) {
  return fetch({
    url: '/staff/getDoctorList',
    contentType: 'application/json',
    baseUrl: HEALTHAPI,
    method: 'post',
    params,
  });
}
//邀请专家
export function inviteDoc(params) {
  return fetch({
    url: '/staff/inviteDoc',
    contentType: 'application/json',
    baseUrl: HEALTHAPI,
    method: 'post',
    params,
  });
}
//医生重新进群
export function docReJoin(params) {
  return fetch({
    url: '/consult/docReJoin',
    contentType: 'application/json',
    baseUrl: HEALTHAPI,
    method: 'post',
    params,
  });
}
//接收/拒绝会话
export function receivesOrDeclines(params) {
  return fetch({
    url: '/consult/receivesOrDeclines',
    contentType: 'application/json',
    baseUrl: HEALTHAPI,
    method: 'post',
    params,
  });
}